<template>
  <form @submit.prevent="createByBtn" @keydown.enter="createByEnter($event)" action="" method="post">
    <div :class="classes.body">
      <slot name="header">
        <div :class="classes.header">
          <p class="text-gray-800 dm-fs-1-1-rem fw-bolder">
            <slot name="title">
              {{ defaultTitle }}
            </slot>
          </p>
          <!--begin::Close-->
          <div v-if="data_.isModal" @click="close" class="btn btn-sm btn-icon btn-active-color-primary">
            <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                      fill="currentColor"/>
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                      fill="currentColor"/>
              </svg>
            </span>
            <!--end::Svg Icon-->
          </div>
          <!--end::Close-->
        </div>
      </slot>
      <div :class="classes.modal_body">
        <div v-if="form">
          <alert-success :form="form" message="Your changes have been saved!"></alert-success>
          <alert-error
              :form="form"
              :message="defaultErrorMessage"
          ></alert-error>
          <div
              v-if="form.errors.has('generic_errors')"
              role="alert"
              class="alert alert-secondary"
          >
            <has-error :form="form" field="generic_errors"></has-error>
          </div>
        </div>
        <slot name="body"></slot>
      </div>
      <slot name="footer-section">
      <div :class="classes.footer">
        <slot name="footer">
          <button :disabled="form && form.busy" type="submit" class="btn btn-primary me-2">{{ data_.saveText }}
          </button>
          <button v-if="data_.isModal"
                  @click="close"
                  type="button"
                  class="btn btn-light ml-1"
          >
            {{ data_.cancelText }}
          </button>
        </slot>
      </div>
      </slot>
    </div>
  </form>
</template>

<script>
const MODAL_CLASSES = {
  modal: 'card mb-4',
  header: 'modal-header',
  modal_body: 'modal-body',
  footer: 'card-footer shadow',
}

const NON_MODAL_CLASSES = {
  modal: '',
  header: 'pb-3',
  modal_body: '',
  footer: '',
}

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    form: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      data__: {
        title: '',
        id: false,
        isModal: true,
        enterSubmit: true,
        saveText: "Save",
        cancelText: "cancel",
      },
    };
  },
  computed: {
    classes(){
      return this.data_.isModal ? MODAL_CLASSES : NON_MODAL_CLASSES
    },
    data_() {
      return this.data ? {...this.data__, ...this.data} : this.data__
    },
    //custom title
    defaultTitle() {
      // if(!this.form) return ''

      let title_ = this.data.title || this.$route.meta.title
      // title_ += ' - '
      // title_ += this.data.id ? 'Edit' : 'Create'
      
      return title_
    }
  },
  methods: {
    createByEnter(event) {
      if (this.data_.enterSubmit) return;
      event.preventDefault()
    },
    createByBtn() {
      this.create()
    },
    create() {
      // if parent component has the method, call it. or emit event
      this.$parent.create ? this.$parent.create() : this.$emit('create')
    },
    close() {
      this.$parent.close ? this.$parent.close() : this.$emit('close')
    },
  },
};
</script>